import {Page} from "@/PageDescriptors";

import GatewayList from "@/components/gateway/GatewayList";
import DeleteGatewayPage from "@/components/gateway/delete/DeleteGatewayPage";
import UpdateGatewayPage from "@/components/gateway/update/UpdateGatewayPage";
import Routing from "@/components/gateway/routing/Routing";
import {EndpointBreadcrumb} from "./tools";
import {defineMessage} from "react-intl";

const gatewaysPage: Page = {
    path: "gateways",
    label: defineMessage({id: "gateway-pages.group-title", defaultMessage: "Gateways"}),
    items: [
        {
            path: "routing",
            label: defineMessage({id: "gateway-pages.routing", defaultMessage: "Routing"}),
            contentComponent: (props: {[s: string]: any}) => <Routing domainId={props.domainId} />,
        },
        {
            path: "gateways",
            label: defineMessage({id: "gateway-pages.gateway-list", defaultMessage: "Gateways"}),
            contentComponent: GatewayList,
            permission: "view_superuser_gateway",
            items: [
                {
                    path: ":gatewayId",
                    label: null,
                    breadcrumbComponent: EndpointBreadcrumb("gateways", "gatewayId"),
                    items: [
                        {
                            path: "settings",
                            label: defineMessage({id: "settings", defaultMessage: "Settings"}),
                            contentComponent: (props: {[s: string]: any}) => (
                                <UpdateGatewayPage id={props.gatewayId} domainId={props.domainId} />
                            ),
                        },
                        {
                            path: "delete",
                            label: defineMessage({id: "delete", defaultMessage: "Delete"}),
                            contentComponent: (props: {[s: string]: any}) => (
                                <DeleteGatewayPage gatewayId={props.gatewayId} domainId={props.domainId} />
                            ),
                        },
                    ],
                },
            ],
        },
    ],
};

export default gatewaysPage;
